<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Uredite opombo:
    </h2>

    <LocationForm
      :barve="false"
      :opomba="true"
      @save="save"
      @cancel="cancel"
      :location="comment"
    />

    <div class="row mt-10">
      <div class="col">
        <h2>
          Skupine:
        </h2>
      </div>
      <div class="col">
        <PopupPickerSkupineOpomba
          :categoryId="id"
          :levelCategories="localCategories"
          :allCategories="categories"
          @izbraneKategorije="temp"
        />
      </div>
    </div>
    <v-row>
      <v-col>
        <v-simple-table fixed-header>
          <template v-slot:default>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row v-dragula="localCategories" drake="articles">
      <v-col cols="12" v-for="item of localCategories" :key="item.id" class="pt-0 pb-0">
        <TitleOnlyCard
          :title="item.name"
          :editable="false"
          :deleteable="true"
          :draggable="false"
          @delete="izbrisiKategorijo(item)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import LocationForm from '@/components/LocationForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'
import TitleOnlyCard from '@/components/TitleOnlyCard'
import PopupPickerSkupineOpomba from '@/components/PopupPickerSkupineOpomba'

export default {
  components: {
    LocationForm,
    PopupPickerSkupineOpomba,
    TitleOnlyCard
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      koncano: false,
      localCategories: []
    }
  },
  computed: {
    comment () {
      return this.$store.state.businessUnits.comments[this.id]
    },
    categories () {
      return objectToArray(this.$store.state.categories.items)
    },
    selectedCategories () {
      return objectToArray(this.$store.state.businessUnits.komentarjiSkupine[this.id])
    }
  },
  methods: {
    ...mapActions('businessUnits', ['setComments', 'setCommentCategory', 'getCommentCategories', 'deleteCommentCategory']),
    ...mapActions('categories', { loadCategories: 'loadItems' }),
    izbrisiKategorijo (item) {
      const orderCommentId = this.id
      const categoryId = item.id
      this.deleteCommentCategory({ orderCommentId, categoryId })
        .then(() => {
          /* this.$notify({
            type: 'success',
            text: 'Skupina je bila uspešno odstranjena!'
          }) */
        })
        .catch((err) => console.log(err.message))
    },
    temp (data) {
      this.localCategories = [ ...this.localCategories, ...data.listaKategorij ]
    },
    save ({ data }) {
      this.setComments(data)
        .then((item) => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno osveženi!'
          }) */

          this.setCommentCategory({ listaKategorij: this.localCategories, commentId: this.id })
            .then(() => {
              this.cancel()
            })
        })
        .catch((err) => {
          if (err.response.status === 400) {
            this.$notify({
              type: 'error',
              text: 'Opombe že obstaja!'
            })
          }
        })
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyComments' })
    }
  },
  created () {
    this.loadCategories()
      .then(response => {
        this.getCommentCategories({ id: this.id })
          .then((kategorije) => {
            this.localCategories = objectToArray(kategorije)
            this.asyncDataStatus_fetched()
            this.koncano = true
          })
      })
  },
  watch: {
    selectedCategories (newCategories) {
      if (this.koncano) {
        this.localCategories = newCategories
      }
    }
  }
}
</script>
